import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";

const AdmAttendanceEntry = () => {
  const [classOptions, setClassOptions] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [lessonPlanData, setLessonPlanData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const navigate = useNavigate();

  const resolveDocumentUrl = (rawUrl) => {
    if (!rawUrl) return "";
    if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
    const baseOrigin = ApiUrl.apiurl.replace(/\/api\/?$/, "");
    const normalizedPath = rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`;
    return `${baseOrigin}${normalizedPath}`;
  };

  const getDocumentName = (row) => {
    if (row?.documentName) return row.documentName;
    if (!row?.documentUrl) return "";

    try {
      return decodeURIComponent(new URL(row.documentUrl).pathname.split("/").pop());
    } catch {
      return row.documentUrl.split("/").pop() || "";
    }
  };

  // Initialize state when lessonPlanData is available
  useEffect(() => {
    if (lessonPlanData.length > 0) {
      setUpdatedData(
        lessonPlanData.map((item) => ({
          LESSON_PLAN_ID: item.LESSON_PLAN_ID,
          TaughtDate: item.TaughtDate || "",
          PercentageCompleted: item.PercentageCompleted || "",
          remarks: item.remarks || "",
          documentName: item.document_name || "",
          documentFile: null,
          documentUrl: resolveDocumentUrl(item.document_url),
        }))
      );
    }
  }, [lessonPlanData]);

  // Handle input change for each row
  const handleInputChange = (index, field, value) => {
    setUpdatedData((prevData) =>
      prevData.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };

  const handleDocumentChange = (index, file) => {
    if (!file) return;
    setUpdatedData((prevData) =>
      prevData.map((row, i) =>
        i === index
          ? {
              ...row,
              documentFile: file,
              documentName: file.name,
              documentUrl: "",
            }
          : row
      )
    );
  };
  // const handleClear = () => {
  //   if (dateFromRef.current) dateFromRef.current.value = "";
  //   if (dateToRef.current) dateToRef.current.value = "";
  //   if (messageTypeRef.current) messageTypeRef.current.value = "";
  //   if (studentNameRef.current) studentNameRef.current.value = "";
  //   if (initiatedByRef.current) initiatedByRef.current.value = "";
  //   if (sectionRef.current) sectionRef.current.value = "";
  //   if (classRef.current) classRef.current.value = "";
  // };

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!selectedClass) {
        setSectionOptions([]); // Clear sections if no class is selected
        return;
      }

      console.log("Fetching sections for classId:", selectedClass.value); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [selectedClass]);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Class/GetAllClass/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions([{ value: "", label: "Select Class" }, ...options]);
        }
      })
      .catch((error) => {
        console.error("Error fetching class data:", error);
      });
  }, []);

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) {
          console.error("Missing orgId or branchId in localStorage");
          return;
        }

        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          // Mapping data to match React Select options format
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const academicSessionId = localStorage.getItem("academicSessionId");

  const fetchLessonPlanData = async () => {
    if (!selectedMentor || !selectedClass || !selectedSection || !selectedSubject) {
      setLessonPlanData([]);
      return;
    }

    const requestUrl = `${ApiUrl.apiurl}LESSION_PLAN/GetTeacherlessionPlanList/?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}&class_id=${selectedClass.value}&section_id=${selectedSection.value}&subject_id=${selectedSubject.value}`;

    const response = await fetch(requestUrl);
    const data = response.status === 204
      ? { message: "No Record Found", data: [] }
      : await response.json();
    if (data && Array.isArray(data.data)) {
      setLessonPlanData(data.data);
    } else {
      setLessonPlanData([]);
    }
  };

  useEffect(() => {
    if (!selectedClass) {
      setSubjectOptions([]);
      return;
    }

    const searchParams = new URLSearchParams({
      academic_year_id: academicSessionId,
      org_id: orgId,
      branch_id: branchId,
      class_id: selectedClass.value,
      section_id: selectedSection ? selectedSection.value : 0,
    });

    fetch(`${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection/?${searchParams}`)
      .then((response) => response.status === 204
        ? { message: "No Record Found", data: [] }
        : response.json())
      .then((data) => {
        if (data && data.message === "success" && data.data) {
          const options = data.data.map((subject) => ({
            value: subject.id,
            label: subject.subjectcode,
          }));
          setSubjectOptions([
            { value: "", label: "Select Subject" },
            ...options,
          ]);
        } else {
          setSubjectOptions([{ value: "", label: "Select Subject" }]);
        }
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
        setSubjectOptions([{ value: "", label: "Select Subject" }]);
      });
  }, [academicSessionId, branchId, orgId, selectedClass, selectedSection]);

  // Fetch Lesson Plan Data when all selections are made
  useEffect(() => {
    fetchLessonPlanData().catch((error) => {
      console.error("Error fetching lesson plan data:", error);
      setLessonPlanData([]);
    });
  }, [
    selectedMentor,
    selectedClass,
    selectedSection,
    selectedSubject,
  ]);

  // Handle update API call
  const handleUpdate = async (index) => {
    const rowData = updatedData[index];
    if (!rowData) return; // Ensure rowData exists

    const { LESSON_PLAN_ID, TaughtDate, PercentageCompleted, remarks, documentName, documentFile } =
      rowData;

    if (!TaughtDate || !PercentageCompleted || !remarks) {
      alert("Please fill in all fields before updating.");
      return;
    }

    // Retrieve userId from sessionStorage
    const userId = sessionStorage.getItem("userId");

    if (!userId) {
      alert("User not logged in. Please log in again.");
      return;
    }

    const formData = new FormData();
    formData.append("TaughtDate", TaughtDate);
    formData.append("PercentageCompleted", PercentageCompleted);
    formData.append("remarks", remarks);
    formData.append("updated_by", userId);
    if (documentName) {
      formData.append("document_name", documentName);
    }
    if (documentFile) {
      formData.append("document_file", documentFile);
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}LESSION_PLAN/GetTeacherlessionPlanupdate/${LESSON_PLAN_ID}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        alert("Teacher lesson plan updated successfully!");
        setUpdatedData((prev) =>
          prev.map((row, i) =>
            i === index
              ? {
                  ...row,
                  documentFile: null,
                  documentName:
                    responseData?.data?.document_name || row.documentName,
                  documentUrl: resolveDocumentUrl(
                    responseData?.data?.document_url || row.documentUrl
                  ),
                }
              : row
          )
        );
        await fetchLessonPlanData();
      } else {
        alert("Failed to update data.");
      }
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Error updating data.");
    }
  };

  const handleSave = () => {
    if (updatedData.length === 0) {
      alert("No lesson plan rows to save.");
      return;
    }
    updatedData.forEach((_, index) => {
      handleUpdate(index);
    });
  };

  const handleClear = () => {
    setSelectedMentor(null);
    setSelectedClass(null);
    setSelectedSection(null);
    setSelectedSubject(null);
    setLessonPlanData([]);
    setUpdatedData([]);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "10px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                TEACHER LESSON PLAN
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="pick-up-point" className="form-label">
                          Teacher
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          onChange={setSelectedMentor}
                          placeholder="Select Mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="class-dropdown"
                          placeholder="Select Class"
                          value={selectedClass}
                          onChange={setSelectedClass} // Set selected class
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          classNamePrefix="section-dropdown"
                          className="detail"
                          placeholder="Select Section"
                          isDisabled={!selectedClass}
                          value={selectedSection} // Add this line to maintain state
                          onChange={setSelectedSection} // Add this line to update state
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="subject" className="form-label">
                          Subject
                        </label>
                        <Select
                          options={subjectOptions}
                          className="detail"
                          classNamePrefix="subject-dropdown"
                          placeholder="Select Subject"
                          isDisabled={!selectedClass}
                          value={selectedSubject}
                          onChange={setSelectedSubject}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {lessonPlanData.length > 0 && updatedData.length > 0 && (
                <div className="col-12 ">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Lecture No</th>
                          <th>Module No</th>
                          <th>Topics Detail</th>
                          <th>Proposed Date</th>
                          <th>Taught Date</th>
                          <th>% Course Coverage</th>
                          <th>Remarks</th>
                          <th>Document Upload</th>
                          <th>View</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {lessonPlanData.map((item, index) => (
                          <tr key={item.LESSON_PLAN_ID}>
                            <td>{item.lectureno}</td>
                            <td>{item.moduleno}</td>
                            <td>{item.topic_details}</td>
                            <td>{item.proposedDate}</td>
                            <td>
                              <input
                                type="date"
                                className="form-control"
                                value={updatedData[index]?.TaughtDate || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "TaughtDate",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                min="0"
                                max="100"
                                placeholder="0 - 100"
                                value={
                                  updatedData[index]?.PercentageCompleted ?? ""
                                }
                                onChange={(e) => {
                                  const val = e.target.value;
                                  // Allow empty string (clearing the field)
                                  if (val === "") {
                                    handleInputChange(index, "PercentageCompleted", "");
                                    return;
                                  }
                                  const num = Number(val);
                                  if (!isNaN(num) && num >= 0 && num <= 100) {
                                    handleInputChange(index, "PercentageCompleted", val);
                                  }
                                }}
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={updatedData[index]?.remarks || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "remarks",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => handleDocumentChange(index, e.target.files?.[0])}
                              />
                              {getDocumentName(updatedData[index]) && (
                                <div
                                  className="small text-muted mt-1 text-truncate"
                                  title={getDocumentName(updatedData[index])}
                                >
                                  Uploaded: {getDocumentName(updatedData[index])}
                                </div>
                              )}
                            </td>
                            <td>
                              {updatedData[index]?.documentUrl ? (
                                <a
                                  href={updatedData[index].documentUrl}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-primary"
                                >
                                  View
                                </a>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              <a
                                href="#"
                                className="text-primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleUpdate(index);
                                }}
                              >
                                Update
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;

